import Ajax from '@utils/ajax';

export default {
  get(options = {}) {
    return Ajax.get({
      url: `/terms_and_privacy`,
      ...options,
    });
  },

  accept(options = {}) {
    return Ajax.post({
      url: '/terms_and_privacy/accept',
      ...options,
    });
  },

  reject(options = {}) {
    return Ajax.post({
      url: '/terms_and_privacy/reject',
      ...options,
    });
  },
};
